import { v4 as uuidv4 } from 'uuid';
import store from '@/store';

export default class UIService {
  constructor($store) {
    this.$store = $store;
  }

  showModal(modal, options = {}) {
    const { modals } = this.$store.state.UIStore;

    const isAlreadyExist = modals.findIndex((m) => m.id === modal.id) !== -1;

    if (isAlreadyExist) {
      return;
    }

    const modalObject = {
      id: uuidv4(),
      component: modal,
      props: options.props ?? {},
      actions: options.actions ?? {},
    };

    this.$store.dispatch('UIStore/showModal', modalObject);
  }

  closeModalById(modalId) {
    this.$store.dispatch('UIStore/closeModalById', modalId);
  }

  clearModals() {
    this.$store.dispatch('UIStore/clearModals');
  }

  showToast(toastName) {
    const toast = {
      id: uuidv4(),
      label: toastName
    };

    this.$store.dispatch('UIStore/showToast', toast);
  }

  showToastWithMessage(message) {
    const toast = {
      id: uuidv4(),
      label: message
    };

    this.$store.dispatch('UIStore/showToast', toast);
  }

  hideToastById(toastId) {
    this.$store.dispatch('UIStore/hideToastById', toastId);
  }
}

export const uiService = new UIService(store);
